import ReportUserGuide from './ReportUserGuide';

export default ReportUserGuide;
